<template>
  <div>
    <h1>用户信息修改</h1>
    <!-- <span>{{this.$route.params.id}}</span> -->
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="用户名称"
      >
        <a-input
          v-decorator="[
          'nickName',
          {rules: [{ required: true, message: '必填项' }],initialValue: formData.nickName}
        ]"
          placeholder="用户名称"
        />
        <a-input
          v-decorator="[
          'id',
          {initialValue: formData.id},
        ]"
          type="hidden"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="电话"
      >
        <a-input
          v-decorator="[
          'phone',
           {initialValue: formData.phone},
        ]"
          placeholder="电话"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="备注"
      >
        <a-input
          v-decorator="[
          'note',
          
          {rules: [{ required: checkNick, message: '必填项' }],
           initialValue: formData.note,}
        ]"
          placeholder="备注"
        />
      </a-form-item>

      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="客户类型"
      >
        <a-select
          v-decorator="[
          'customerType',
          {rules: [{ required: true, message: '请选择客户类型' }],initialValue: ''+formData.customerType}
        ]"
          placeholder="客户类型"
        >
          <a-select-option
            v-for="option in customerType"
            v-bind:key="option.value"
          >{{ option.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
        <div>
          <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
          <a-button @click="goBack">取消</a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
export default {
  name: "userUpdate",
  created() {
    this.$http
      .get("/api/1.0/dict/list", { "query-ownGroup-eq": "Gender" })
      .then(res => {
        this.genderList = res.data;
      });
    this.$http
      .get("/api/1.0/dict/list", { "query-ownGroup-eq": "CustomerGroup" })
      .then(res => {
        this.customerType = res.data;
      });
  },
  mounted() {
    this.getInfoById(this.$route.params.id);
  },
  data() {
    return {
      customerType: [],
      genderList: [],
      checkNick: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this),
      formData: {}
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post("/api/1.0/account/update", values).then(res => {
            this.$http.ajaxResultDue(res, "/user", null);
          });
        }
      });
    },
    getInfoById(id) {
      const url = "/api/1.0/account/get/" + id;
      this.$http.get(url).then(res => {
        this.formData = res.data;
      });
    },
    goBack() {
      this.$router.push({ path: "/user" });
    }
  }
};
</script>
